import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { PORTAL_LIGHTBOX_PRIORITY } from '@rsos/capstone/src/constants/portalPriorities';
import Modal from '@rsos/components/capstone/base/Modal';
import EllingtonCardList from './EllingtonCardList';

export const ADRContainer = ({ onActionableButton }) => {
  const [isActive, setIsActive] = useState(false);
  const [zoomedURL, setZoomedURL] = useState('');

  const handleZoom = useCallback((imageURL = '') => {
    setZoomedURL(imageURL);
    setIsActive(prev => !prev);
  }, []);

  return (
    <>
      <Modal
        id="card-image-modal"
        className="card-image-modal"
        portalPriority={PORTAL_LIGHTBOX_PRIORITY}
        isOpened={isActive}
        onClose={() => {
          setZoomedURL('');
          setIsActive(false);
        }}
      >
        <img
          className="default-type-string-format-image-actual"
          src={zoomedURL}
        />
      </Modal>
      <EllingtonCardList
        onZoom={handleZoom}
        onActionableButton={onActionableButton}
      />
    </>
  );
};

ADRContainer.propTypes = {
  onActionableButton: PropTypes.func,
};

ADRContainer.defaultProps = {
  onActionableButton: () => {},
};

export default React.memo(ADRContainer);
